import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const BASE_URL = "https://senutour.com/api";

const villes = ["Toutes", "Dakar", "Diamniadio", "Saly", "Saint-Louis", "Ziguinchor", "Thiès"];
const categories = ["Toutes", "Sénégalaise", "Fruits de mer", "Grillades & BBQ", "Café & Snacks", "Fast-food", "Mixte", "Végétarien"];

const IconPin = ({ size = 14, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconStar = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#E8834A">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);
const IconClose = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 6L6 18M6 6l12 12"/>
  </svg>
);
const IconSearch = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8B5E3C" strokeWidth="2">
    <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/>
  </svg>
);
const IconClock = ({ size = 44, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconWhatsapp = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="white">
    <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4c-4.37 0-7.92 3.55-7.92 7.92 0 1.4.37 2.76 1.07 3.96L4 20l4.24-1.11a7.9 7.9 0 0 0 3.8.97h.01c4.37 0 7.92-3.55 7.92-7.92a7.87 7.87 0 0 0-2.37-5.62zm-5.55 12.2h-.01a6.57 6.57 0 0 1-3.35-.92l-.24-.14-2.5.65.67-2.44-.16-.25a6.58 6.58 0 0 1-1.01-3.5c0-3.64 2.96-6.6 6.6-6.6a6.56 6.56 0 0 1 4.67 1.94 6.56 6.56 0 0 1 1.93 4.66c0 3.64-2.96 6.6-6.6 6.6zm3.62-4.94c-.2-.1-1.17-.58-1.35-.64-.18-.07-.32-.1-.45.1-.13.2-.51.64-.63.77-.12.13-.23.15-.43.05-.2-.1-.83-.3-1.58-.97a5.94 5.94 0 0 1-1.1-1.36c-.11-.2-.01-.3.09-.4.09-.1.2-.23.3-.35.1-.12.13-.2.2-.33.07-.13.03-.25-.02-.35-.05-.1-.45-1.08-.61-1.48-.16-.39-.32-.33-.45-.34-.11-.01-.25-.01-.38-.01-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.66s.72 1.93.82 2.06c.1.13 1.41 2.16 3.42 3.02.48.21.85.33 1.14.42.48.15.92.13 1.26.08.38-.06 1.17-.48 1.34-.94.16-.46.16-.86.11-.94-.05-.08-.18-.13-.38-.23z"/>
  </svg>
);
const IconPhoneCall = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.82 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.09 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

export default function ListeRestaurants() {
  const navigate = useNavigate();
  const [villeActive, setVilleActive]         = useState("Toutes");
  const [categorieActive, setCategorieActive] = useState("Toutes");
  const [search, setSearch]                   = useState("");
  const [selected, setSelected]                = useState(null);
  const [restaurants, setRestaurants]          = useState([]);
  const [chargement, setChargement]            = useState(true);

  useEffect(() => {
    const fetchRestaurants = async () => {
      setChargement(true);
      try {
        const params = new URLSearchParams();
        if (villeActive !== "Toutes") params.append("ville", villeActive);
        if (categorieActive !== "Toutes") params.append("type", categorieActive);

        const res = await fetch(`${BASE_URL}/restaurants?${params}`);
        const data = await res.json();
        setRestaurants(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur chargement restaurants:", error);
        setRestaurants([]);
      } finally {
        setChargement(false);
      }
    };
    fetchRestaurants();
  }, [villeActive, categorieActive]);

  const filtered = restaurants.filter(r => {
    const matchSearch = (r.nom || "").toLowerCase().includes(search.toLowerCase())
      || (r.ville || "").toLowerCase().includes(search.toLowerCase());
    return matchSearch;
  });

  const formatPrix = (p) => p ? `~${Number(p).toLocaleString("fr-FR")} F` : "Prix variable";

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
        .resto-card { transition: all .3s; border: 1.5px solid rgba(28,16,8,0.06); cursor: pointer; }
        .resto-card:hover { transform: translateY(-5px); box-shadow: 0 20px 50px rgba(28,16,8,0.12) !important; }
        .resto-img { transition: transform .4s; }
        .resto-card:hover .resto-img { transform: scale(1.04); }
        .filter-pill { cursor: pointer; transition: all .2s; border: 1.5px solid rgba(28,16,8,0.12); }
        .filter-pill:hover { border-color: #C4441A; color: #C4441A; }
        .btn-whatsapp { background: #25D366; transition: background .2s; border: none; cursor: pointer; }
        .btn-whatsapp:hover { background: #1DA851; }
        .btn-reserve { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
        .btn-reserve:hover { background: #A03614; }
        .modal-overlay { position: fixed; inset: 0; background: rgba(28,16,8,0.6); z-index: 100; display: flex; align-items: center; justify-content: center; padding: 16px; backdrop-filter: blur(4px); }
        .modal-box { background: #FAF5EC; border-radius: 16px; width: 100%; max-width: 640px; max-height: 90vh; overflow-y: auto; box-shadow: 0 20px 60px rgba(28,16,8,0.3); }
        @media (max-width: 767px) {
          .resto-grid { grid-template-columns: 1fr !important; }
          .filters-row { flex-wrap: wrap !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      <section style={{
        background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)",
        padding: "100px 5% 60px", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:"radial-gradient(circle, rgba(196,68,26,.08) 1px, transparent 1px)", backgroundSize:"26px 26px" }} />
        <div style={{ maxWidth:1200, margin:"0 auto", position:"relative", zIndex:1 }}>
          <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, fontWeight:700, letterSpacing:3, color:"#C4441A", textTransform:"uppercase", marginBottom:12 }}>
            Gastronomie au Sénégal
          </p>
          <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(28px,5vw,56px)", fontWeight:800, color:"white", lineHeight:1.1, letterSpacing:"-1.5px", marginBottom:16 }}>
            Les meilleures tables du{" "}
            <span style={{ color:"#E8834A", fontStyle:"italic" }}>Sénégal</span>
          </h1>
          <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:16, color:"rgba(255,255,255,.6)", maxWidth:520, lineHeight:1.7 }}>
            Thiéboudienne, yassa, fruits de mer, cuisine casamançaise — découvrez les saveurs authentiques de chaque région.
          </p>
        </div>
      </section>

      {/* Filtres + recherche */}
      <section style={{ padding: "32px 5% 0", maxWidth: 1200, margin: "0 auto" }}>
        <div className="filters-row" style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap", marginBottom:16 }}>
          <div style={{ position:"relative", flex:1, minWidth:200 }}>
            <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)" }}><IconSearch /></span>
            <input
              placeholder="Rechercher un restaurant, une ville…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ width:"100%", padding:"10px 14px 10px 36px", border:"1.5px solid rgba(28,16,8,0.12)", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif", fontSize:14, background:"white", outline:"none", color:"#1C1008" }}
            />
          </div>
        </div>

        <div className="filters-row" style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:8 }}>
          {villes.map(v => (
            <button key={v} className="filter-pill"
              onClick={() => setVilleActive(v)}
              style={{ padding:"6px 14px", borderRadius:20, fontFamily:"'Space Grotesk',sans-serif", fontSize:13, fontWeight:600, background: villeActive === v ? "#C4441A" : "white", color: villeActive === v ? "white" : "#1C1008", border: villeActive === v ? "1.5px solid #C4441A" : "1.5px solid rgba(28,16,8,0.12)", cursor:"pointer" }}>
              {v}
            </button>
          ))}
        </div>

        <div className="filters-row" style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:32 }}>
          {categories.map(c => (
            <button key={c} className="filter-pill"
              onClick={() => setCategorieActive(c)}
              style={{ padding:"6px 14px", borderRadius:20, fontFamily:"'Space Grotesk',sans-serif", fontSize:13, fontWeight:500, background: categorieActive === c ? "#1C1008" : "white", color: categorieActive === c ? "white" : "#1C1008", border: categorieActive === c ? "1.5px solid #1C1008" : "1.5px solid rgba(28,16,8,0.12)", cursor:"pointer" }}>
              {c}
            </button>
          ))}
        </div>
      </section>

      {/* Grille restaurants */}
      <section style={{ padding: "0 5% 80px", maxWidth: 1200, margin: "0 auto" }}>
        {chargement ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#7A5A3A", fontFamily: "'Space Grotesk',sans-serif" }}>Chargement…</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "80px 20px" }}>
            <div style={{ display:"flex", justifyContent:"center", marginBottom:28 }}>
              <div style={{ width:90, height:90, borderRadius:"50%", background:"rgba(196,68,26,.08)", border:"2px dashed rgba(196,68,26,.25)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                <IconClock size={44} color="#C4441A" />
              </div>
            </div>
            <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(22px,3vw,32px)", fontWeight:800, marginBottom:12 }}>
              Aucun restaurant pour l'instant
            </h2>
            <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:15, color:"#7A5A3A", maxWidth:440, margin:"0 auto" }}>
              Essayez d'autres filtres, ou revenez bientôt — de nouveaux restaurants s'inscrivent régulièrement sur la plateforme.
            </p>
          </div>
        ) : (
          <div className="resto-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(300px, 1fr))", gap:24 }}>
            {filtered.map(r => (
              <div key={r.id} className="resto-card"
                onClick={() => setSelected(r)}
                style={{ background:"white", borderRadius:16, overflow:"hidden", boxShadow:"0 4px 20px rgba(28,16,8,0.06)" }}>
                <div style={{ overflow:"hidden", height:200, background: "linear-gradient(135deg,#1C1008,#2D1A08)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {r.images?.[0]
                    ? <img className="resto-img" src={r.images[0]} alt={r.nom} style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                    : <span style={{ fontSize: 44, opacity: 0.4 }}>🍽️</span>
                  }
                </div>
                <div style={{ padding:"20px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                    <h3 style={{ fontFamily:"'Fraunces',serif", fontSize:18, fontWeight:800, color:"#1C1008", margin:0 }}>{r.nom}</h3>
                    <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, fontWeight:700, color:"#7A5A3A" }}>{formatPrix(r.prixMoyen)}</span>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:8 }}>
                    <IconPin size={12} />
                    <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"#7A5A3A" }}>{r.quartier ? `${r.quartier}, ` : ""}{r.ville}</span>
                  </div>
                  {r.note > 0 && (
                    <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:12 }}>
                      <IconStar />
                      <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, fontWeight:700, color:"#1C1008" }}>{r.note}</span>
                      <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"#B8A898" }}>({r.avis || 0} avis)</span>
                    </div>
                  )}
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                    {r.type && (
                      <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:600, background:"rgba(196,68,26,0.08)", color:"#C4441A", padding:"3px 10px", borderRadius:20 }}>{r.type}</span>
                    )}
                    {(r.equipements || []).slice(0, 2).map(eq => (
                      <span key={eq} style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:600, background:"#FAF5EC", color:"#7A5A3A", padding:"3px 10px", borderRadius:20, border: "1px solid #E8DCC8" }}>{eq}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Modal détail */}
      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div style={{ position:"relative" }}>
              {selected.images?.[0]
                ? <img src={selected.images[0]} alt={selected.nom} style={{ width:"100%", height:220, objectFit:"cover", borderRadius:"16px 16px 0 0" }} />
                : <div style={{ width:"100%", height:220, background:"linear-gradient(135deg,#1C1008,#2D1A08)", borderRadius:"16px 16px 0 0", display:"flex", alignItems:"center", justifyContent:"center", fontSize:56, opacity:0.4 }}>🍽️</div>
              }
              <button onClick={() => setSelected(null)} style={{ position:"absolute", top:12, right:12, background:"white", border:"none", borderRadius:"50%", width:36, height:36, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", boxShadow:"0 2px 8px rgba(0,0,0,0.2)" }}>
                <IconClose />
              </button>
            </div>
            <div style={{ padding:"24px" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
                <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:24, fontWeight:800, color:"#1C1008", margin:0 }}>{selected.nom}</h2>
                <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:700, color:"#7A5A3A" }}>{formatPrix(selected.prixMoyen)}</span>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:6 }}>
                <IconPin />
                <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#7A5A3A" }}>{selected.quartier ? `${selected.quartier}, ` : ""}{selected.ville}</span>
              </div>
              {selected.note > 0 && (
                <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:16 }}>
                  <IconStar />
                  <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:700 }}>{selected.note}</span>
                  <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#B8A898" }}>({selected.avis || 0} avis)</span>
                </div>
              )}
              {selected.description && (
                <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, color:"#7A5A3A", lineHeight:1.7, marginBottom:20 }}>{selected.description}</p>
              )}
              <div style={{ display:"flex", gap:16, marginBottom:20, fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#7A5A3A", flexWrap: "wrap" }}>
                {selected.horaires && <span>🕐 {selected.horaires}</span>}
                {selected.telephone && <span>📞 {selected.telephone}</span>}
              </div>

              {(selected.equipements || []).length > 0 && (
                <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginBottom:24 }}>
                  {selected.equipements.map(eq => (
                    <span key={eq} style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, fontWeight:600, background:"rgba(196,68,26,0.08)", color:"#C4441A", padding:"4px 12px", borderRadius:20 }}>{eq}</span>
                  ))}
                </div>
              )}

              <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                {selected.reservationActive !== false && (
                  <button className="btn-reserve" onClick={() => navigate("/reservation-restaurant", { state: {
                    id: selected.id, nom: selected.nom, ville: selected.ville, quartier: selected.quartier, telephone: selected.telephone,
                  } })}
                    style={{ flex: 1, minWidth: 180, color:"white", borderRadius:10, padding:"12px 20px", fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:700 }}>
                    Réserver une table
                  </button>
                )}
                {selected.whatsapp && (
                  <a href={`https://wa.me/${selected.whatsapp.replace(/[\s+]/g, "")}`} target="_blank" rel="noreferrer" style={{ textDecoration: "none", flex: selected.reservationActive === false ? 1 : "none", minWidth: selected.reservationActive === false ? 180 : "auto" }}>
                    <button className="btn-whatsapp" style={{ width: selected.reservationActive === false ? "100%" : "auto", color:"white", borderRadius:10, padding:"12px 16px", fontFamily:"'Space Grotesk',sans-serif", fontSize:14, fontWeight:700, display:"flex", alignItems:"center", justifyContent: "center", gap:8 }}>
                      <IconWhatsapp /> WhatsApp
                    </button>
                  </a>
                )}
                {selected.telephone && (
                  <a href={`tel:${selected.telephone}`} style={{ textDecoration: "none" }}>
                    <button style={{ background:"white", border:"1.5px solid #E8DCC8", borderRadius:10, padding:"12px 16px", fontSize:14, fontWeight:700, color:"#1C1008", cursor:"pointer", display:"flex", alignItems:"center", gap:8 }}>
                      <IconPhoneCall />
                    </button>
                  </a>
                )}
              </div>
              {selected.reservationActive === false && (
                <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"#7A5A3A", marginTop:10, lineHeight:1.5 }}>
                  Cet établissement ne prend pas de réservation en ligne — contactez-le directement, les clients sont accueillis selon les disponibilités.
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}